import React from 'react';
import { hasPermission } from 'utils/permissions/permissions';
import { useSelector } from 'react-redux';
import { userTypeSelector } from 'redux/modules/session/selectors';

interface ICanPerformProps {
	action: string | undefined;
	yes?: React.ReactElement | null;
	no?: React.ReactElement | null;
}

const CanPerform = ({ action = 'default', yes = null, no = null }: ICanPerformProps) => {
	const userType = useSelector(userTypeSelector);
	return hasPermission(userType, action) ? yes : no;
};

export default CanPerform;
